jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{ variant.id }}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });

});

//Pagination
function pagination(class_name){
  pageSize = 10;
  incremSlide = 11;
  startPage = 0;
  numberPage = 0;
  
  var pageCount =  $(".line-content"+class_name).length / pageSize;
  var totalSlidepPage = Math.floor(pageCount / incremSlide);
  $("#pagin").html('');
  for(var i = 0 ; i<pageCount;i++){
      $("#pagin").append('<li data-id="'+(i+1)+'"><a href="javascript:void(0)">'+(i+1)+'</a></li> ');
      if(i>pageSize){
         $("#pagin li").eq(i).hide();
      }
  }
  
  var prev = $("<li/>").attr('data-id', '1').addClass("yith-faqs-page yith-faqs-first prev-page").html("<a href='javascript:void(0)'><span aria-hidden='true'>«</span></a>").click(function(){
     startPage-=11;
     incremSlide-=11;
     numberPage--;
     slide();
  });
  
  //prev.hide();
  if(Math.floor(pageCount)+1 > 1){
    var next_page_no = 2;
  }else{
    var next_page_no = 1;
  }

  var next = $("<li/>").attr('data-id', next_page_no).addClass("yith-faqs-page yith-faqs-last next-page").html("<a href='javascript:void(0)'><span aria-hidden='true'>»</span></a>").click(function(){
     startPage+=11;
     incremSlide+=11;
     numberPage++;
     slide();
  });
  
  $("#pagin").prepend(prev).append(next);
  
  $("#pagin li:nth-child(2)").addClass("active");
  
  slide = function(sens){
     //$("#pagin li").hide();
     //alert(numberPage);
     for(t=startPage;t<incremSlide;t++){
       $("#pagin li").eq(t+1).show();
     }
     /*if(startPage == 0){
       next.show();
       prev.hide();
     }else if(numberPage == totalSlidepPage ){
       next.hide();
       prev.show();
     }else{
       next.show();
       prev.show();
     }*/
     
      
  }
  
  showPage = function(page) {
  	  $(".line-content"+class_name).hide();
  	  $(".line-content"+class_name).each(function(n) {
  	      if (n >= pageSize * (page - 1) && n < pageSize * page)
  	          $(this).show();
  	  });        
  }
      
  showPage(1);
  $("#pagin li:nth-child(2)").addClass("active");
  
  $("#pagin li").click(function() {
      
  	 $("#pagin li").removeClass("active");
  	 // $(this).addClass("active");
  	 showPage(parseInt($(this).attr('data-id')));

    var pageNo = parseInt($(this).attr('data-id'));
    $("#pagin li[data-id="+pageNo+"]").addClass("active");

    if(Math.floor(pageCount)+1 == pageNo){
      $('.next-page').attr('data-id', Math.floor(pageCount)+1).removeClass('active');
    }else{
      $('.next-page').attr('data-id', (pageNo+1)).removeClass('active');  
    }

    if(pageNo == 1){
      $('.prev-page').attr('data-id', 1).removeClass('active');
    }else{
       $('.prev-page').attr('data-id', (pageNo-1)).removeClass('active'); 
    }
    
  });
}
pagination('');
//filter category

var checkClass = function() {
  if ( $('.item').hasClass('hide') ) {
    $('.item').removeClass('hide');
  }
};

$('.all').click( function() {
  checkClass();
  pagination('');
});
$('.yith-faqs-categories .epoxy').click( function() {
  checkClass();
  $('.item:not(.epoxy)').toggleClass('hide');
  pagination('.epoxy');
});
$('.yith-faqs-categories .silicone').click( function() {
  checkClass();
  $('.item:not(.silicone)').toggleClass('hide');
  pagination('.silicone');
});
$('.yith-faqs-categories .casting').click( function() {
  checkClass();
  $('.item:not(.casting)').toggleClass('hide');
  pagination('.casting');
});
$('.yith-faqs-categories .moulding').click( function() {
  checkClass();
  $('.item:not(.moulding)').toggleClass('hide');
  pagination('.moulding');
});
$('.yith-faqs-categories .polyurethanes').click( function() {
  checkClass();
  $('.item:not(.polyurethanes)').toggleClass('hide');
  pagination('.polyurethanes');
});
$('.yith-faqs-categories .foam-sheets').click( function() {
  checkClass();
  $('.item:not(.foam-sheets)').toggleClass('hide');
  pagination('.foam-sheets');
});
$('.yith-faqs-categories .postage').click( function() {
  checkClass();
  $('.item:not(.postage)').toggleClass('hide');
  pagination('.postage');
});

// Active tag
$('.button').click(function(){
  $('.button').removeClass('active');
  $(this).addClass('active');
})
//
$(document).ready(function(){
  $(".privacy-sidebar .collection-cat-link .product-list-item li a").click(function(){
    $(".side-menu-dropdown").toggleClass("show");
  });
});
// search filter

 $("#filter").keyup(function() {

      // Retrieve the input field text and reset the count to zero
      var filter = $(this).val(),
        count = 0;

      // Loop through the comment list
      $('#accordion .line-content button').each(function() {


        // If the list item does not contain the text phrase fade it out
        if ($(this).text().search(new RegExp(filter, "i")) < 0) {
          $(this).parent().parent().parent().hide();  // MY CHANGE

          // Show the list item if the phrase matches and increase the count by 1
        } else {
          $(this).show(); // MY CHANGE
          count++;
        }

      });

    });




